import 'moment/locale/fi';
import moment from 'moment';
import React from 'react';
import DatePicker from 'react-datepicker';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { bindActionCreators } from 'redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { requestDestinationList } from '../actions/destination';
import { setSubNavbar } from '../actions/navbar';
import { requestOrder } from '../actions/order';
import FileInput from '../components/forms/FileInput';
import Icon from '../components/forms/Icon';
import Input from '../components/forms/Input';
import RadioButton from '../components/forms/RadioButton';
import Select from '../components/forms/Select';
import TextArea from '../components/forms/TextArea';
import ServiceSiteList from '../components/servicesite/ServiceSiteList';
import CloseIcon from '../images/close_red.png';
import NewIcon from '../images/new.png';
import './Order.css';

class Order extends React.Component {
  DESTINATION_TYPE = Object.freeze({
    new: 'new',
    existing: 'existing',
  });

  constructor(props) {
    super(props);

    this.state = {
      destinationType: this.DESTINATION_TYPE.new,
      destinationId: undefined,
      destinationInstructionAttachments: [],
      destinationStartDate: null,

      serviceSiteRowId: 0,
      serviceSiteRowIds: [0],
    };
  }

  componentDidMount() {
    const { translate, setSubNavbar } = this.props;

    setSubNavbar({
      title: [
        translate('navigation.order'),
      ],
    });
  }

  onDestinationTypeChanged = (evt) => {
    const { destinationList, requestDestinationList } = this.props;

    let { serviceSiteRowId } = this.state;
    serviceSiteRowId++;

    const destinationType = evt.target.value;

    this.setState({
      destinationType,
      destinationId: undefined,
      destinationInstructionAttachments: [],
      destinationStartDate: null,

      serviceSiteRowId,
      serviceSiteRowIds: [serviceSiteRowId],
    });

    if (destinationType === this.DESTINATION_TYPE.existing && !destinationList) {
      requestDestinationList();
    }
  }

  onExistingDestinationSelected = (evt) => {
    const { target: { value } = {} } = evt;

    const destinationId = value || undefined;
    let { serviceSiteRowId } = this.state;
    serviceSiteRowId++;

    this.setState({
      destinationId,

      serviceSiteRowId,
      serviceSiteRowIds: [serviceSiteRowId],
    });
  };

  onDestinationInstructionAttachmentsAdded = (evt) => {
    const { destinationInstructionAttachments } = this.state;

    this.setState({
      destinationInstructionAttachments: [
        ...destinationInstructionAttachments,
        ...evt.target.files,
      ],
    });
  };

  onDestinationInstructionAttachmentRemove = (evt) => {
    const { destinationInstructionAttachments } = this.state;

    const attachments = destinationInstructionAttachments.slice();
    attachments.splice(evt.index, 1);

    this.setState({
      destinationInstructionAttachments: attachments,
    });
  };

  onDestinationStartDateChange = (destinationStartDate) => {
    this.setState({ destinationStartDate });
  };

  onAppendServiceSiteRow = () => {
    const { serviceSiteRowIds } = this.state;
    let { serviceSiteRowId } = this.state;
    serviceSiteRowId++;

    this.setState({
      serviceSiteRowId,
      serviceSiteRowIds: [
        ...serviceSiteRowIds,
        serviceSiteRowId,
      ],
    });
  };

  onDeleteServiceSiteRow = (rowNumber) => {
    const { serviceSiteRowIds: rowIdsState } = this.state;

    const serviceSiteRowIds = rowIdsState.slice();
    serviceSiteRowIds.splice(rowNumber, 1);

    this.setState({
      serviceSiteRowIds,
    });
  };

  onSubmit = (evt) => {
    const { requestOrder, translate } = this.props;
    const { destinationInstructionAttachments, serviceSiteRowIds } = this.state;

    evt.preventDefault();

    const formData = new FormData(evt.target);

    destinationInstructionAttachments.forEach((attachment) => {
      formData.append('destination.instructionAttachments', attachment);
    });

    const serviceSiteProperties = [
      'name',
      'serviceSiteId',
      'group',
      'serviceText',
      'siteInfo',
    ];

    serviceSiteRowIds.forEach((id, index) => {
      serviceSiteProperties.forEach((propertyName) => {
        const formKey = `serviceSites[${id}].${propertyName}`;

        const value = formData.get(formKey);
        formData.delete(formKey);

        formData.set(`serviceSites[${index}].${propertyName}`, value);
      });
    });

    let date = formData.get('destination.startDate');
    if (date) {
      date = moment(date, translate('change_order_properties.date-format'))
        .format('YYYY-MM-DD');
      formData.set('destination.startDate', date);
    }

    requestOrder(formData, this.onOrderError, this.onOrderSuccess);
  };

  onOrderSuccess = () => {
    const { translate, navigate } = this.props;
    const { requestDestinationList } = this.props;

    toast(translate('order_request.success'));

    requestDestinationList();
    navigate('/');
  }

  onOrderError = () => {
    const { translate } = this.props;

    toast.error(translate('order_request.error'));
  }

  renderDestinationTypeSelection() {
    const { translate } = this.props;

    return (
      <div>
        <div className="row">
          <div className="col-sm-4">
            <label className="text-4">
              <RadioButton name="destination.type" value={this.DESTINATION_TYPE.new} defaultChecked onChange={this.onDestinationTypeChanged} />
              {translate('new_destination')}
            </label>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-4">
            <label className="text-4">
              <RadioButton name="destination.type" value={this.DESTINATION_TYPE.existing} onChange={this.onDestinationTypeChanged} />
              {translate('existing_destination')}
            </label>
          </div>
        </div>
      </div>
    );
  }

  renderNewDestination() {
    const { translate, currentLanguage } = this.props;
    const { destinationInstructionAttachments, destinationStartDate } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-sm-4">
            <Input name="destination.companyName" placeholder={translate('destination_properties.name')} required />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-4">
            <Input name="destination.streetAddress" placeholder={translate('destination_properties.street_address')} required />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-2 col-xs-6">
            <Input name="destination.postalCode" placeholder={translate('destination_properties.postal_code')} required />
          </div>
          <div className="col-sm-2 col-xs-6">
            <Input name="destination.city" placeholder={translate('destination_properties.post_office')} required />
          </div>
        </div>

        <h2>{translate('destination_properties.service_description_title')}</h2>
        <div className="row">
          <div className="col-sm-6">
            <TextArea name="destination.customServiceText" placeholder={translate('destination_properties.service_description_placeholder')} required rows={10} />
          </div>
          <div className="col-sm-3 text-5 additional-info-color">
            {translate('destination_properties.service_description_help')}
          </div>
        </div>

        <h2>{translate('destination_properties.start_date_title')}</h2>
        <div className="row">
          <div className="col-sm-2 col-xs-6">
            <DatePicker
              name="destination.startDate"
              className="app-date-picker-input"
              selected={destinationStartDate}
              onChange={this.onDestinationStartDateChange}
              dateFormat={['dd.MM.yyyy', 'd.M.yyyy', 'dd.M.yyyy', 'd.MM.yyyy']}
              strictParsing
              locale={currentLanguage === 'fi' ? 'fi' : 'en'}
              placeholderText={translate('destination_properties.start_date_placeholder')}
              popperClassName="app-date-picker-popper"
              portalId="app-date-picker-portal"
              showPopperArrow={false}
              required />
          </div>
        </div>

        <h2>{translate('destination_properties.instructions_title')}</h2>
        <div className="row">
          <div className="col-sm-6">
            <TextArea name="destination.instructions" placeholder={translate('destination_properties.instructions_placeholder')} required rows={10} />
          </div>
          <div className="col-sm-3 text-5 additional-info-color">
            {translate('destination_properties.instructions_help')}
          </div>
        </div>
        {destinationInstructionAttachments.length > 0
          && (
          <div className="row">
            <div className="col-sm-12">
              <FileInput.List files={destinationInstructionAttachments} onRemove={this.onDestinationInstructionAttachmentRemove} />
            </div>
          </div>
          )}
        <div className="row">
          <div className="col-sm-12">
            <FileInput className="vertical-middle" multiple onChange={this.onDestinationInstructionAttachmentsAdded}>
              <Icon src={NewIcon} alt={translate('destination_properties.instructions_attachment')} />
              <h2 className="primary-color inline-block">{translate('destination_properties.instructions_attachment')}</h2>
            </FileInput>
          </div>
        </div>
      </div>
    );
  }

  renderExistingDestination() {
    const { translate, destinationList = [], currentLanguage } = this.props;
    const { destinationStartDate } = this.state;

    const orderDestinationList = [];
    if (destinationList.length !== 0) {
      destinationList.data.map((dat) => orderDestinationList.push(dat));
    }

    return (
      <div>
        <div className="row">
          <div className="col-sm-6">
            <Select name="destination.id"
                    placeholder={translate('destination.singular')}
                    required
                    onChange={this.onExistingDestinationSelected}
                    data={orderDestinationList.map((destination) => ({
                      value: destination.id,
                      text: `${destination.companyName}, ${destination.streetAddress}`,
                    }))} />
          </div>
        </div>

        <h2>{translate('destination_properties.start_date_title')}</h2>
        <div className="row">
          <div className="col-sm-2 col-xs-6">
            <DatePicker
              name="destination.startDate"
              className="app-date-picker-input"
              selected={destinationStartDate}
              onChange={this.onDestinationStartDateChange}
              dateFormat={['dd.MM.yyyy', 'd.M.yyyy', 'dd.M.yyyy', 'd.MM.yyyy']}
              strictParsing
              locale={currentLanguage === 'fi' ? 'fi' : 'en'}
              placeholderText={translate('destination_properties.start_date_placeholder')}
              popperClassName="app-date-picker-popper"
              portalId="app-date-picker-portal"
              showPopperArrow={false}
              required />
          </div>
        </div>
      </div>
    );
  }

  renderServiceSiteRow(rowNumber, id, allowDelete) {
    const { translate } = this.props;

    const formInputs = (
      <div className="row">
        <div className="col-sm-3">
          <Input name={`serviceSites[${id}].name`} placeholder={translate('service_site_properties.name')} required />
        </div>
        <div className="col-sm-3">
          <Input name={`serviceSites[${id}].serviceSiteId`} placeholder={translate('service_site_properties.identification')} required />
        </div>
        <div className="col-sm-3">
          <Input name={`serviceSites[${id}].group`} placeholder={translate('service_site_properties.group')} required />
        </div>

        <div className="col-sm-6">
          <Input name={`serviceSites[${id}].serviceText`} placeholder={translate('service_site_properties.service')} required />
        </div>
        <div className="col-sm-6">
          <Input name={`serviceSites[${id}].siteInfo`} placeholder={translate('service_site_properties.instructions')} required />
        </div>
      </div>
    );

    return (
      <div className="order-service-site-row" key={id}>
        <div className="fit-content">
          <h2 className="primary-color inline-block">{`${rowNumber + 1}.`}</h2>
        </div>
        <div className="order-service-site-row-inputs">
          {formInputs}
        </div>
        <div className="fit-content">
          <div className={`order-service-site-row-delete clickable${allowDelete ? '' : ' invisible'}`} onClick={() => this.onDeleteServiceSiteRow(rowNumber)}>
            <Icon className="no-margin" src={CloseIcon} />
          </div>
        </div>
      </div>
    );
  }

  renderServiceSites() {
    const { translate } = this.props;

    const { destinationId, serviceSiteRowIds } = this.state;
    const { destinationMap: { [destinationId]: { serviceSites } = {} } = {} } = this.props;

    return (
      <div>
        <h2>{translate('service_site.plural')}</h2>

        {!!serviceSites
          && (
          <div className="row">
            <div className="col-sm-10">
              <ServiceSiteList serviceSites={serviceSites} />
            </div>
          </div>
          )}

        <div className="row">
          <div className="col-sm-12">
            {serviceSiteRowIds.map((serviceSiteRowId, rowNumber) => this.renderServiceSiteRow(rowNumber, serviceSiteRowId, serviceSiteRowIds.length > 1))}
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 vertical-middle clickable" onClick={this.onAppendServiceSiteRow}>
            <Icon src={NewIcon} />
            <h2 className="primary-color inline-block">{translate('append_row')}</h2>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { translate } = this.props;
    const { destinationType, destinationId } = this.state;

    return (
      <div className="container normal-color">
        <form onSubmit={this.onSubmit}>
          {this.renderDestinationTypeSelection()}

          {destinationType === this.DESTINATION_TYPE.new ? this.renderNewDestination() : this.renderExistingDestination()}

          {(destinationType === this.DESTINATION_TYPE.new || destinationId !== undefined)
            && this.renderServiceSites()}

          <div className="row">
            <div className="col-sm-2">
              <Input type="reset" value={translate('form.reset')} />
            </div>
            <div className="col-sm-2">
              <Input type="submit" value={translate('form.submit')} />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { locale, destination: { destinationList, destinationMap } } = state;

  return {
    translate: getTranslate(locale),
    currentLanguage: getActiveLanguage(locale).code,
    destinationList,
    destinationMap,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setSubNavbar,
  requestDestinationList,
  requestOrder,
}, dispatch);

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return (
      <Component
                {...props}
                location={location}
                navigate={navigate}
                params={params} />
    );
  }
  return ComponentWithRouterProp;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Order));
